module.exports = __webpack_public_path__ + "706461cfbb89af101bf14ebb795d0fbd.fbx";